export default __webpack_public_path__ + "static/WatercolorLine-79e794aced03998e951cdd6293458e57.svg";